import { useHistory } from 'react-router-dom'
import { FormattedMessage, useIntl } from 'react-intl'
import React, { useCallback, useMemo } from 'react'

import { getCookie } from '../../components/common/cookie'
import { localizeResource } from '../../services/utilities'
import { useErrorModal, useHasActivity } from '../../services/hooks'
import Loading from '../../components/Loading'

import styles from './Campaign.module.css'

const ACTIVITY_CODE = 17
const DIVE_SHOPS_URL = 'https://www.padi.com.cn/dive-shops/nearby'

export default function CampaignHomePage() {
  const { push } = useHistory()
  const showErrorModal = useErrorModal()
  const { formatMessage } = useIntl()
  const { loading, data } = useHasActivity(ACTIVITY_CODE)
  const language = getCookie('language')

  // 缓存本地化图片模块，避免在 render 中重复 require
  const images = useMemo(() => {
    const bgImg = localizeResource('bg.jpg', language)
    const cardImg = localizeResource('card.jpg', language)
    return {
      bg: require(`../../assets/images/campaign/newyear/${bgImg}`),
      card: require(`../../assets/images/campaign/newyear/${cardImg}`),
      displayArea: require('../../assets/images/campaign/newyear/display-area.png'),
    }
  }, [language])

  const handleAction = useCallback(() => {
    if (!data) return

    if (data.binded) {
      showErrorModal(formatMessage({ id: 'card-requested' }))
      return
    }

    if (data.hasCard) {
      push('/newYearCampaign')
      return
    }

    window.location.href = DIVE_SHOPS_URL
  }, [data, push, showErrorModal, formatMessage])

  if (loading) return <Loading />
  if (!data) return null

  const { hasCard } = data

  return (
    <div className={styles.wrapper}>
      <div className={styles['card-post']}>
        <img src={images.bg} alt="new year" />
        <div className={styles['area-wrapper']}>
          <img src={images.displayArea} alt="title" className={styles['area-bg']} />
          <div className={styles['content-wrapper']}>
            <div className={styles.title}>
              <FormattedMessage id="newyear-title1" />
            </div>
            <div className={styles.title}>
              <FormattedMessage id="newyear-title2" />
            </div>
            <img src={images.card} alt="card" className={styles.card} />
            {hasCard ? (
              <div className={styles.btn} onClick={handleAction}>
                <FormattedMessage id="newyear-btn1" />
              </div>
            ) : (
              <div className={styles['non-diver-btn']} onClick={handleAction}>
                <div>
                  <FormattedMessage id="newyear-btn2" />
                </div>
                <div>
                  <FormattedMessage id="newyear-btn3" />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
